import React from "react";

const UpperFilter = () => {
  return (
    <div id="upperFilter">
      <button>All</button>
      <button>Movies</button>
      <button>Worldcup</button>
      <button>Songs</button>
      <button>Devotional</button>
      <button>Latest</button>
      <button>Reels</button>
      <button>Shorts</button>
      <button>News</button>
      <button>Playlist</button>
      <button>Channel</button>
    </div>
  );
};

export default UpperFilter;
